import { InputNumber } from 'primereact/inputnumber'

import i18n from '../../utils/i18n'

export const PercentFilterTemplate = (options: any) => {
  if (!options || options.value == null) return null

  const { language } = i18n

  return (
    <InputNumber
      value={options.value}
      onChange={e => options.filterCallback(e.value, options.index)}
      min={0}
      minFractionDigits={2}
      locale={language}
      placeholder={i18n.t('common.placeholders.searchPercentage')}
      suffix=" %"
      showButtons
    />
  )
}
